export const initialNodeData = [
    {
        id: 'A',
        type: 'flowNode',
        data: { 
          label: 'Shopify: User Checksout Product',
          shape: 'rounded-rect',
          bgColor: '#f5f5dc',
          parent: null,
          children: ['B']
        },
    },
    {
        id: 'B',
        type: 'flowNode',
        data: { 
          label: 'Wait 3 hours',
          shape: 'circle',
          bgColor: '#444',
          parent: 'A',
          children: ['C']
        },
    },
    {
        id: 'C',
        type: 'flowNode',
        data: { 
          label: 'Send "Forgot Something?" Email',
          shape: 'action',
          parent: 'B',
          children: ['D']
        },
    },
    {
        id: 'D',
        type: 'flowNode',
        data: { 
          label: 'Wait 1 day',
          shape: 'circle',
          bgColor: '#444',
          parent: 'C',
          children: ['E']
        },
    },
    {
        id: 'E',
        type: 'flowNode',
        data: { 
          label: 'Send "Checkout Recommended Products" Email',
          shape: 'action',
          parent: 'D',
          children: ['F']
        },
    },
    {
        id: 'F',
        type: 'flowNode',
        data: { 
          label: 'End Flow',
          shape: 'rounded-rect',
          bgColor: '#f5f5dc',
          parent: 'E',
          children: []
        },
    },
]; 

export const initialNodeDataAbstract = [
  {
      id: 'A',
      data: {
        action: "TRIGGER",
        label: 'Send "Forgot Something?" Email',
        parent: null,
        children: ['B']
      }
  },
  {
      id: 'B',
      data: {
        action: "WAIT",
        label: 'Wait 3 hours',
        parent: 'A',
        children: ['C']
      }
  },
  {
      id: 'C',
      data: {
        action: "EMAIL",
        label: 'Send "Forgot Something?" Email',
        parent: 'B',
        children: ['D']
      }
  },
  {
      id: 'D',
      data: {
        action: "SMS",
        label: 'Send "Checkout Recommended Products" SMS',
        parent: 'C',
        children: null
      }
  }
]; 